exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".YouTubeFrame {\n  position: relative;\n  min-width: 300px;\n  padding-bottom: 56.25%;\n  height: 0;\n  margin-bottom: 10px; }\n  .YouTubeFrame-IFrame {\n    position: absolute;\n    width: 100%;\n    max-width: 70ch;\n    max-height: calc(1080 / 1920 * 70ch);\n    height: 100%;\n    min-width: 265px;\n    min-height: 170px; }\n", ""]);

// exports
